import { useContext, useEffect, useMemo, useCallback, useState } from 'react';
import { BaseNewAndDetail, getDarkThemeClass, defErrProps } from '../../utility';
import { useTheme } from '@emotion/react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';


import _ItemsTab from './_ItemsTab';
import _CategoryTab from './_CategoryTab';
import _WasteReasonsTab from './_WasteReasonsTab';
import _WasteMethodTab from './_WasteMethodsTab';

import { WasteBreadCrumbs } from '../../utility/BreadcrumbLinks';
import { FarmContext } from '../../../context/FarmContext';
import apiService from '../../../api/apiService';


export default function Waste(props) {
  const [values, setValues] = useState({
    openItemsPopup: false,
    items: []
  });
// const [values, setValues] = useState({});

  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const {farmContextValue, setFarmContextValue} = useContext(FarmContext);

  const theme = useTheme();
  const { waste, integrationid } = useParams();

  const currentTab = waste || 'Waste';
  const currDarkThemeClass = useMemo(() => getDarkThemeClass(theme), [theme?.palette?.themeMode]);

  const baseEntityName = 'Waste';
//   const itemsTagKey = 'item';
//   const categoryTagKey = 'category';
  const wasteTagKey1 = 'Reason'
  const wasteTagKey2 = 'Method'
  const baseSaveBtnChildren = 'Add Item';
  const itemsKey = 'item';

  const tabEntityMap = [
    // { key: itemsTagKey, label: 'Items', defaultForDetail: true, validForNew: false },
    // { key: categoryTagKey, label: 'Category', defaultForDetail: false, validForNew: false },
    { key: wasteTagKey1, label: 'Waste Reason', defaultForDetail: true, validForNew: false },
    { key: wasteTagKey2, label: 'Waste Method', defaultForDetail: false, validForNew: false },


  ];

  const defUndVal = '';
  const navigate = useNavigate();

  const breadcrumbsProps = {
    currLink: currentTab,
    currDarkThemeClass,
    navigate,
  };
  const breadcrumbs = <WasteBreadCrumbs {...breadcrumbsProps} />;

//   const breadcrumbs = <ItemBreadCrumbs {...breadcrumbsProps} />;

  useEffect(() => {
            // Automatically fetch farms when app starts
            const fetchFarms = async () => {
                try {
                    const response = await apiService.fetchInstance("farm/?fetch_farms=true");
                    
                    setFarmContextValue(response?.data || { farms: [] });
                } catch (error) {
                    console.error("Error fetching farms", error);
                    setFarmContextValue({ farms: [] }); // fallback
                }
            };
            fetchFarms();
        }, []);

  const handleErrorWithFeedback = feedbackCX => (handleSetValues, errPropsFn) => err => {
    console.log('error occureed');
    handleSetValues('error', true);
    handleSetValues('loading', true);
    const errProps = errPropsFn?.(err) ?? defErrProps;

    feedbackCX?.setContextValue?.(true, errProps);
  };

  const handleSetLoading = prop => value => handleSetValues('loading', { ...values?.loading, [prop]: value });

  const handleEntityEntryCreateRes = prop => res => {
    handleSetLoading(prop)(false);

    const { data } = res;
    const newState = data?.length > 0 ? [...values?.[prop], ...data] : [...values?.[prop], data];

    handleSetValues(prop, newState);

    return Promise.resolve({ success: true });
  };
  const handleEntityEntryModifyRes = prop => res => {
    const { data } = res;

    handleSetValues(
      prop,
      values?.[prop]?.map(e => (e.id === data.id ? data : e))
    );

    return Promise.resolve({ success: true });
  };
  const handleSetValues = useCallback((prop, value) => {
    setValues(state => ({ ...state, [prop]: value }));
  }, [setValues]);
  
  const toDisable = () => {
    // different toDisable conditions based on tab
    switch (tab) {
      default:
        return false;
    }
  };

  const handleSave = () => {
    if (tab === itemsKey)
    handleSetValues('openItemsPopup', true);
  };

  const getDefaultTabForEndpoint = () => tabEntityMap?.find(tab => tab?.defaultForDetail)?.key;

  const itemTagsprops = {
    currDarkThemeClass,
    values,
    items: values?.items,
    open: values?.openItemsPopup,
    addNew: values?.add ?? false,
    update: values?.update ?? false,
    handleErrorWithFeedback,
    handleEntityEntryCreateRes,
    handleEntityEntryModifyRes,
    handleSetValues,
  };
  const categoryprops = {
    currDarkThemeClass,
    items: values?.itmes,
    openItemsPopup: values?.openItemsPopup ?? false,
    addNew: values?.add ?? false,
    update: values?.update ?? false,
    handleErrorWithFeedback,
    handleEntityEntryCreateRes,
    handleEntityEntryModifyRes,
    handleSetValues,
  };
  const wasteprops={
    currDarkThemeClass,
  }
  const tabContentMap = {
    // [itemsTagKey]: <_ItemsTab {...itemTagsprops} />,
    // [categoryTagKey]: <_CategoryTab {...categoryprops} />,
    [wasteTagKey1]: <_WasteReasonsTab{...wasteprops}/>,
    [wasteTagKey2]:<_WasteMethodTab{...wasteprops}/>
  };
  const tabCreateTitleMap = {
    // [wasteTagKey1]: 'Waste',
    // [wasteTagKey2]: 'Waste',
  };
  const showSaveBtn = tab => Object.keys(tabCreateTitleMap).includes(tab);

  const baseProps = {
    baseEntityName,
    baseid: undefined,
    currDarkThemeClass,
    tabContentMap,
    tabEntityMap,
    breadcrumbs,
    createBaseEntityMsg: '',
    baseSaveBtnChildren,
    baseEndpointCheck: false,
    enablePopup: true,
    showSaveBtn,
    handleSave,
    toDisable,

    getDefaultTabForEndpoint,
  };
  return <BaseNewAndDetail {...baseProps} />;
}
